import { TextFieldProps } from "@mui/material";
import { forwardRef } from "react";
import { NumberFormatValues, NumericFormat } from "react-number-format";

import { TextField } from "./TextField";

type DollarTextFieldProps = Omit<TextFieldProps, "onChange"> & {
  allowNegative?: boolean;
  onChange: (value: number | undefined) => void;
  currencySymbol?: string;
};

export const DollarTextField = forwardRef<HTMLInputElement, DollarTextFieldProps>(
  ({ allowNegative, onChange, currencySymbol = "$", ...props }, ref) => {
    const handleValueChange = (values: NumberFormatValues) => {
      onChange(values.floatValue); // Extract the integer value
    };

    return (
      // TODO: Figure the props error out
      // @ts-ignore
      <NumericFormat
        inputRef={ref}
        customInput={TextField}
        allowNegative={allowNegative}
        thousandSeparator=","
        prefix={currencySymbol}
        onValueChange={handleValueChange}
        valueIsNumericString={true}
        {...props}
      />
    );
  }
);

DollarTextField.displayName = "DollarTextField";

export default DollarTextField;
